"use strict";
// TODO: Rename to CancellationPolicyType
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingType = void 0;
var PricingType;
(function (PricingType) {
    PricingType["NonRefundable"] = "NonRefundable";
    PricingType["Flexible"] = "Flexible";
    PricingType["SuperFlexible"] = "SuperFlexible";
})(PricingType || (exports.PricingType = PricingType = {}));
//# sourceMappingURL=PricingType.js.map